import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class NoPlayFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.NoPlay;
    }

    getRawFragment() {
        const rawPlay = "NOPLAY:";
        return rawPlay;
    }
}
